export default __webpack_public_path__ + "static/media/eye.f84d36e0.svg";